export class ProgressData {
    loaded: number;
    total: number;
    percentage: number;
}